import React, { useState } from 'react';
import { useCart } from '../hooks/useCart';
import logo from '../assets/logo-somzita.png';

interface HeaderProps { onCartOpen: () => void; }

export default function Header({ onCartOpen }: HeaderProps) {
  const { count } = useCart();
  const [pressed, setPressed] = useState(false);

  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 100,
      padding: '0 var(--page-px)',
      height: '56px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: 'rgba(8,10,12,0.92)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderBottom: '1px solid var(--border)',
    }}>
      {/* Logo image */}
      <img
        src={logo}
        alt="Somzita"
        style={{
          height: '36px',
          width: 'auto',
          objectFit: 'contain',
        }}
      />

      {/* Bouton panier */}
      <button
        onClick={onCartOpen}
        onTouchStart={() => setPressed(true)}
        onTouchEnd={() => setPressed(false)}
        style={{
          display: 'flex', alignItems: 'center', gap: '0.45rem',
          background: pressed ? 'rgba(168,196,162,0.1)' : 'none',
          border: '1px solid var(--border)',
          color: 'var(--text)',
          padding: '0 0.9rem',
          height: 'var(--touch-min)',
          borderRadius: '2rem',
          fontSize: '0.82rem',
          transition: 'background 0.15s',
          minWidth: 'var(--touch-min)',
        }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/>
        </svg>
        <span>Panier</span>
        {count > 0 && (
          <span style={{
            background: 'var(--accent)', color: 'var(--bg)',
            fontSize: '0.65rem', fontWeight: 600,
            minWidth: '1.25rem', height: '1.25rem',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '0 0.2rem',
          }}>
            {count}
          </span>
        )}
      </button>
    </header>
  );
}
